.breakdownContent {
  margin-top: 1.5rem;
}

.chartLegend {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: start;
  margin: 1.5rem;
}

.chartLegendItem {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--static-divider-standard);
}

.chartLegendColor {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.1875rem;
}

.chartLegendLabel {
  font-size: var(--fs-small);
  font-weight: 500;
  line-height: 1.25rem;
  color: var(--static-text-strong);

}

.chartTooltip {
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  align-items: flex-start;
  gap: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid var(--static-divider-standard);
  background: var(--static-background-standard);
  box-sizing: border-box;
}

.chartTooltipLabel {
  font-size: var(--fs-small);
  color: #525252;
}

.chartTooltipData {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: baseline;

}

.chartTooltipDataValue {
  color: var(--color-black);
  font-size: var(--fs-small-heading);
  font-weight: 500;
  line-height: 0.5rem;
}

.chartTooltipDataLabel {
  font-size: var(--fs-small);
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
}

.chartTooltipDataRevenue {
  composes: chartTooltipDataLabel;
  color: var(--primary-enabled);
}

.chartTooltipDataProfit {
  composes: chartTooltipDataLabel;
  color: var(--sentiment-text-positive);
}

.chartTooltipDataUnits {
  composes: chartTooltipDataLabel;
  color: #5823FF;
}

.chartTooltipDataRefunds {
  composes: chartTooltipDataLabel;
  color: var(--color-black);
}

.chartProfitLine path {
  stroke: var(--sentiment-text-positive);
  stroke-width: 2;
}

.chartUnitsLine path {
  stroke: #5823FF;
  stroke-width: 2;
}

.chartRefundsLine path {
  stroke: var(--static-background-inverse-standard);
  stroke-width: 2;
}

.chartRevenueBar path {
  fill: var(--primary-enabled);
  opacity: 0.75;
}

.chartRevenueBar path.chartRevenueBarActive {
  opacity: 1;
}

.chartGrid {
  stroke: var(--static-divider-standard);
  stroke-dasharray: 3 3;
}

.chartYAxis text {
  font-size: var(--fs-small);
  line-height: 1rem;
  fill: var(--static-text-weak);
}

.chartLeftYAxis {
  transform: translateX(-0.5rem);
}

.chartLeftYAxis g text {
  text-anchor: end;
}

.chartRightYAxis {
  transform: translateX(0.5rem);
}

.chartRightYAxis g text {
  text-anchor: start;
}

.chartXAxis line {
  stroke: var(--static-divider-standard);
  stroke-dasharray: 3 3;
}

.chartXAxis text {
  font-size: var(--fs-small);
  line-height: 1rem;
  fill: var(--static-text-weak);
  text-anchor: middle;
}

.chartLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 360px;
  border-radius: 0.75rem;
}

.heading {
  margin-left: 2rem;
}